
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans/history",
      function () {
        return require("private-next-pages/plans/history/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plans/history"])
      });
    }
  